import { render, staticRenderFns } from "./SocialConnectGoogle.vue?vue&type=template&id=12b46754&"
import script from "./SocialConnectGoogle.vue?vue&type=script&lang=js&"
export * from "./SocialConnectGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports